import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Handout from './pages/about/Handout';
import Events from './pages/events/Events';
import Contact from './pages/contact/Contact';
import Support from './pages/support/Support';
import Media from './pages/media/Media';
import Publications from './pages/media/publications';
import Videos from './pages/media/videos';
import Markers from './pages/media/markers';
import ScrollToTop from './components/ScrollToTop';
import RSVP from './pages/rsvp/RSVP';
import Admin from './pages/admin/Admin';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/handout" element={<Handout />} />
          <Route path="/events" element={<Events />} />
          {/* Aliases for links already in circulation (email blasts, printed notices). */}
          {/* Do not remove: "/event" is the URL HCHS puts in its member emails. */}
          <Route path="/event" element={<Navigate to="/events" replace />} />
          <Route path="/rsvp" element={<Navigate to="/events" replace />} />
          <Route path="/media" element={<Media />} />
          <Route path="/media/publications" element={<Publications />} />
          <Route path="/media/videos" element={<Videos />} />
          <Route path="/media/markers" element={<Markers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/rsvp/:eventSlug" element={<RSVP />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
